/**
 * Lock marker shown beside the name of views and cards that are restricted to
 * elevated-access roles (super users / global admins).
 */
import { Lock } from 'lucide-react'
import { cn } from '@/lib/utils'

export function AccessLock({ className }: { className?: string }) {
  return (
    <Lock
      aria-label="Restricted access"
      className={cn('h-4 w-4 shrink-0', className)}
    />
  )
}
